import {POSITIONS} from '../mutation-types';
import {Rastreador} from '../class/';

export const modulePositions = {
    state: {
        list: [],
    },

    mutations: {
        [POSITIONS.SET_ONE] (state, pos) {
            state.list.push(pos);
        }
    },

    getters: {
        getByRastreador: (state) => (id) => {
            return state.list.find(todo => todo.id_rastreador === id);
        },
        all: (state) => {
            return state.list;
        }
    },

    actions: {
        async [POSITIONS.BY_PK] ({commit}, id) {
            let veiculo = await Rastreador.getLastPosition(id);
            if (veiculo) {
                commit(POSITIONS.SET_ONE, veiculo);
            }
        }
    }
};
